// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
unit-picker breadcrumbs {
  margin-bottom: 2px;
}
unit-picker .header {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
unit-picker .header h1 {
  color: var(--c_textBody);
}
unit-picker .header .searchRow {
  display: flex;
  margin: 12px 88px 2px;
}
unit-picker .header .searchRow visiba-input {
  flex-grow: 1;
}
unit-picker .header .searchRow visiba-input input {
  width: 100%;
  box-sizing: border-box;
  outline: 0;
}
unit-picker .unit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-top: 2px;
  cursor: pointer;
}
unit-picker .unit.-offer {
  justify-content: flex-start;
}
unit-picker .unit.-offer visiba-svg {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}
unit-picker .unit visiba-svg {
  width: 13px;
  height: 22px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
